@use "../../../variables.scss";

.navigation-bar {
  display: flex;
  flex-direction: column;
  align-items: start;
  position: relative;
  height: 100%;

  @media (min-width: variables.$bp-medium) {
    width: unset;
    min-width: 27.2rem;
  }
}
